export default {"src":"/_next/static/media/favorite.4b238a0f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};